import { useEffect } from 'react';

import { useOidc } from '@axa-fr/react-oidc';
import { COOKIE_NAMES, getCookie, isElectron } from '@fly/shared';
import { useFullStory } from '@fly/shared-hooks';
import { useUser } from '@fly/shared-hooks';

export const FullStoryInit = () => {
  const { init, setVars, identify } = useFullStory();
  const { isAuthenticated } = useOidc();
  const { udid, email } = useUser();

  useEffect(() => {
    const isDev = process.env.NODE_ENV === 'development';
    init(isDev);
    setVars('document', {
      env: process.env.NODE_ENV || 'development',
      platform: isElectron() ? 'electron' : 'web',
    });
  }, [init, setVars]);

  useEffect(() => {
    if (isAuthenticated && udid && email) {
      identify(udid, {
        udid: udid,
        team: getCookie(COOKIE_NAMES.TEAM_NAME),
        isInternalUser: email.toLowerCase().endsWith('@jfrog.com'),
      });
    }
  }, [udid, isAuthenticated, identify, email]);

  return null;
};
